import { render, staticRenderFns } from "./itUser.vue?vue&type=template&id=1a84ea02&scoped=true&"
import script from "./itUser.vue?vue&type=script&lang=js&"
export * from "./itUser.vue?vue&type=script&lang=js&"
import style0 from "./itUser.vue?vue&type=style&index=0&id=1a84ea02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a84ea02",
  null
  
)

export default component.exports